import type { ReactNode } from "react";

import { cx } from "../lib/cx";
import { useTheme } from "../theme/theme-context";
import type { ThemeMode } from "../theme/theme-context";
import { MonitorIcon, MoonIcon, SunIcon } from "../ui/icons";

const options: { mode: ThemeMode; label: string; Icon: (props: object) => ReactNode }[] = [
  { mode: "light", label: "Light", Icon: SunIcon },
  { mode: "dark", label: "Dark", Icon: MoonIcon },
  { mode: "system", label: "System", Icon: MonitorIcon },
];

/** Segmented light / dark / system control. Mod+Shift+L cycles the same state. */
export function ThemeToggle(): ReactNode {
  const { mode, setMode } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className="flex items-center gap-0.5 rounded-md border border-line p-0.5"
    >
      {options.map(({ mode: value, label, Icon }) => (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={mode === value}
          aria-label={label}
          title={label}
          onClick={() => {
            setMode(value);
          }}
          className={cx(
            "rounded p-1.5",
            mode === value ? "bg-accent text-on-accent" : "text-muted hover:bg-hover",
          )}
        >
          <Icon />
        </button>
      ))}
    </div>
  );
}
